export function ListNumberIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4.5 4a.5.5 0 01.5.5v3a.5.5 0 01-1 0V5.707l-.146.147a.5.5 0 11-.708-.708l1-1A.498.498 0 014.5 4zM9 5a1 1 0 000 2h11a1 1 0 100-2H9zM9 11a1 1 0 100 2h11a1 1 0 100-2H9zM8 18a1 1 0 011-1h11a1 1 0 110 2H9a1 1 0 01-1-1zM4.067 16.25A.5.5 0 114.5 17a.5.5 0 000 1 .5.5 0 11-.5.5.5.5 0 00-1 0 1.5 1.5 0 102.618-1 1.5 1.5 0 10-2.417-1.75.5.5 0 00.866.5zM4.5 10.5a.5.5 0 00-.495.428.5.5 0 11-.99-.14 1.5 1.5 0 112.52 1.297l-.87.915H5.5a.5.5 0 010 1h-2a.5.5 0 01-.362-.845l1.692-1.78.011-.01A.5.5 0 004.5 10.5z"
      ></path>
    </svg>
  );
}
